import { render } from "./ConfirmationDialog.html?vue&type=template&id=52d47961&ts=true&external"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__